import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import ProductCategories from './components/ProductCategories';
import WhyChooseGI2 from './components/WhyChooseGI2';
import StatsShowcase from './components/StatsShowcase';
import OrderingProcess from './components/OrderingProcess';
import FeaturedProducts from './components/FeaturedProducts';
import DealerProgram from './components/DealerProgram';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import GetQuoteModal from '../../components/feature/GetQuoteModal';
import CatalogueModal from '../../components/feature/CatalogueModal';
import BrandWatermark from '../../components/feature/BrandWatermark';
import { useSEO } from '../../utils/seo';

export default function HomePage() {
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [showCatalogueModal, setShowCatalogueModal] = useState(false);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://gi2merchants.com';

  useSEO({
    title: 'GI2 Merchants LLP - B2B Printer Consumables Supplier | Toner, Ink & Lamination Products',
    description: 'GI2 Merchants LLP is a trusted B2B supplier of printer consumables across India. Offering bulk pricing on toner cartridges, ink, OPC drums, lamination pouches, and more. Contact Sanyam Gupta at +91-97111-65605 or Gi2official.in@gmail.com',
    keywords: 'printer consumables, toner cartridges, ink cartridges, OPC drums, lamination pouches, B2B supplier, bulk pricing, GI2 Merchants, Delhi',
    canonical: siteUrl,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'GI2 Merchants LLP - B2B Printer Consumables Supplier',
      description: 'Trusted B2B supplier of printer consumables across India. Bulk pricing on toner, ink, OPC drums & lamination products.',
      url: siteUrl,
      mainEntity: {
        '@type': 'Organization',
        name: 'GI2 Merchants LLP',
        url: siteUrl,
        logo: 'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/2a37b6d757d6280d333da9c2ada73839.png',
        description: 'B2B supplier of printer consumables including toner cartridges, ink, OPC drums, and lamination products across India',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '49, Darya Ganj, Behind Yes Bank',
          addressLocality: 'New Delhi',
          addressRegion: 'Delhi',
          postalCode: '110002',
          addressCountry: 'IN',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+91-97111-65605',
          contactType: 'sales',
          email: 'Gi2official.in@gmail.com',
          areaServed: 'IN',
          availableLanguage: ['en', 'hi'],
        },
      },
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero onGetQuote={() => setShowQuoteModal(true)} />
      <ProductCategories 
        onDownloadCatalogue={() => setShowCatalogueModal(true)}
        onGetQuote={() => setShowQuoteModal(true)}
      />
      <div className="relative">
        <BrandWatermark variant="subtle" position="top-right" size="large" />
        <WhyChooseGI2 />
      </div>
      <StatsShowcase />
      <OrderingProcess />
      <FeaturedProducts onQuickEnquiry={() => setShowQuoteModal(true)} />
      <div className="relative">
        <BrandWatermark variant="subtle" position="bottom-left" size="large" />
        <DealerProgram />
      </div>
      <Testimonials />
      <div className="relative">
        <BrandWatermark variant="subtle" position="center" size="large" />
        <FAQ />
      </div>

      {showQuoteModal && (
        <GetQuoteModal onClose={() => setShowQuoteModal(false)} />
      )}

      {showCatalogueModal && (
        <CatalogueModal onClose={() => setShowCatalogueModal(false)} />
      )}
    </div>
  );
}
